const selectedTab = "";
export default {
     selectedTab
}